import { useM3Mutation } from '@/api/m3';
import { useToast } from '@/components/kit/Toast';
import { errorText } from '@/features/base/shared/useUndoable';

/**
 * Отправка окна M3: мутация, тост, закрытие. Ошибка — текстом сервера
 * как есть (ТЗ §5), окно остаётся открытым, введённое не теряется.
 */
export function useM3Submit<T>(fn: () => Promise<T>, done: string | ((result: T) => string), onDone: (result: T) => void) {
  const toast = useToast();
  const m = useM3Mutation(fn);
  return {
    pending: m.isPending,
    submit: () =>
      m.mutate(undefined, {
        onSuccess: (result) => {
          toast.show(typeof done === 'function' ? done(result) : done);
          onDone(result);
        },
        onError: (e) => toast.showError(errorText(e)),
      }),
  };
}

/** Действие без окна: «Взять в работу», «Поднять из резерва» */
export function useM3Action() {
  const toast = useToast();
  const m = useM3Mutation((fn: () => Promise<unknown>) => fn());
  return {
    pending: m.isPending,
    run: <T>(fn: () => Promise<T>, done: string | ((r: T) => string)) =>
      m.mutate(fn, {
        onSuccess: (r) => toast.show(typeof done === 'function' ? done(r as T) : done),
        onError: (e) => toast.showError(errorText(e)),
      }),
  };
}
